import React from 'react';
import { Modal } from '@fortress-technology-solutions/fortress-component-library/Molecules_Fortress';
import { Form } from '@fortress-technology-solutions/fortress-component-library/Organisms';
import { ChecklistIcon } from '@fortress-technology-solutions/fortress-component-library/Icons';
import useApplicationChecklistModal from './hooks';

export default function ApplicationChecklistModal({
  open,
  handleClose,
  checklistItems,
  applicant,
  applicationDecisionStatuses,
  handleMultipleChecklistOptionsChange,
  isResident,
  propertyId,
  organizationId,
  isCanceled,
}) {
  const { reactHookFormProps, formFields, handleSave, saving, cleanUp } =
    useApplicationChecklistModal({
      checklistItems,
      applicationDecisionStatuses,
      applicant,
      handleMultipleChecklistOptionsChange,
      handleClose,
      isResident,
      propertyId,
      organizationId,
      isCanceled,
    });

  return (
    <Modal
      open={open}
      onClose={() => cleanUp(true)}
      title="Application Checklist"
      icon={<ChecklistIcon />}
      actionsProps={[
        {
          variant: 'text',
          children: 'Cancel',
          onClick: () => cleanUp(true),
        },
        {
          children: <>Save</>,
          submitButton: true,
          onClick: handleSave,
          disabled: !reactHookFormProps.isDirty || isResident || isCanceled,
          isSubmitting: saving,
        },
      ]}
      ContentProps={{
        sx: {
          width: {
            xs: 'calc(100% - 32px)',
            sm: 416,
          },
          pt: 2,
        },
      }}
    >
      <Form
        spacing={1}
        ReactHookFormProps={reactHookFormProps}
        fields={formFields}
      />
    </Modal>
  );
}
